module.exports = __webpack_public_path__ + "static/media/illustration-expression.b9356d1d.svg";